import { CSSProperties, useState } from 'react';

import { AppDownloadModal } from '../../../../../components/AppDownloadModal/AppDownloadModal';
import { AppStoreButtons } from '../../../../../components/Clickables/Buttons/AppStoreButtons/AppStoreButtons';
import { Button } from '../../../../../components/Clickables/Buttons/Button';
import { Heading } from '../../../../../components/Heading/Heading';
import { Text } from '../../../../../components/Text/Text';
import { useAnalytics } from '@domain/analytics/AnalyticsContext';
import { trackEvent } from '@domain/analytics/trackEvent';
import MapDrawSignupBackground from '../../../assets/MapDrawSignupBackground.svg';

interface IProps {
  className?: string;
  headingText: string;
  bodyText: string;
  downloadButtonText: string;
  customStyle?: CSSProperties;
}

export const MapDrawerSignup = ({
  className = '',
  customStyle,
  headingText,
  bodyText,
  downloadButtonText,
}: IProps) => {
  const { currentPage } = useAnalytics();
  const [isAppDownloadModalOpen, setIsAppDownloadModalOpen] = useState(false);

  const downloadButtonClick = (): void => {
    trackEvent({
      name: 'mykiss_cta_button_clicked',
      properties: {
        source: 'MapDrawerSignup',
        type: 'downloadModal',
        page: currentPage,
      },
    });
    setIsAppDownloadModalOpen(true);
  };

  return (
    <div
      style={{
        ...customStyle,
        backgroundImage: `url(${MapDrawSignupBackground.src})`,
      }}
      className={`${className} z-mid absolute inset-x-0 bottom-0 flex w-full flex-col items-center justify-center bg-cover bg-bottom bg-no-repeat pt-[55px] pb-6`}
    >
      <Heading variant="sm" className="mx-6 mt-12 mb-4 text-center">
        {headingText}
      </Heading>
      <Text variant="sm" className="mx-4 mb-4 text-center">
        {bodyText}
      </Text>
      <Button variant="buttonPrimary" onClick={downloadButtonClick} className="hidden sm:flex">
        {downloadButtonText}
      </Button>
      <div className="flex w-full items-center justify-center sm:hidden">
        <AppStoreButtons orientation="vertical" source="MapDrawerSignup" />
      </div>
      <AppDownloadModal
        appDownloadSource="MapDrawerSignup"
        isModalOpen={isAppDownloadModalOpen}
        onCloseModal={() => setIsAppDownloadModalOpen(false)}
      />
    </div>
  );
};
